import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import LoadingDots from "./LoadingDots";
import you from '../images/boy.png';
import bot from '../images/happy.png';
import Mainmenu from "./Mainmenu";

const Details = () => {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');

  const [showFrame, setShowFrame] = useState(false);
  const [showFrame1, setShowFrame1] = useState(false);
  const [showFrame2, setShowFrame2] = useState(false);

  const [showInput, setShowInput] = useState(true);
  const [showInput1, setShowInput1] = useState(false);
  const [showInput2, setShowInput2] = useState(false);

  const [time, setTime] = useState(null);
  const [time1, setTime1] = useState(null);
  const [time2, setTime2] = useState(null);

  const nameRef = useRef(null);
  const mobileRef = useRef(null);
  const emailRef = useRef(null);

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^[A-Za-z\s]*$/.test(value)) {
      setName(value);
    } else {
      alert('Please enter a valid name');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.length === 0) {
      alert('Please Enter Your Name');
      return;
    }
    setTime(new Date());
    setShowFrame(true);
    setShowInput(false);
    setShowInput1(true);
  };

  const handleChange1 = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value)) {
      setMobile(value);
    } else {
      alert('Please enter a valid mobile number');
    }
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    if (mobile.length !== 10) {
      alert('Please Enter Valid Mobile Number');
      return;
    }
    setTime1(new Date());
    setShowFrame1(true);
    setShowInput1(false);
    setShowInput2(true);
  };

  const handleChange2 = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please Enter Valid Email');
      return;
    }
    setTime2(new Date());
    setShowInput2(false);

    try {
      const response = await axios.post('https://dairy-api-kzjx.onrender.com/register', {
        name,
        mobile_number: mobile,
        email,
      });

      if (response.status === 200) {
        console.log("Data stored successfully");
        setShowFrame2(true);
      } else {
        alert('Failed to register. Please try again.');
      }
    } catch (error) {
      alert('Error: ' + (error.response?.data?.error || 'Failed to connect to the server.'));
    }
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);

  // Auto-focus effects
  useEffect(() => {
    if (showInput && nameRef.current) {
      nameRef.current.focus();
    }
  }, [showInput]);

  useEffect(() => {
    if (showInput1 && mobileRef.current) {
      mobileRef.current.focus();
    }
  }, [showInput1]);

  useEffect(() => {
    if (showInput2 && emailRef.current) {
      emailRef.current.focus();
    }
  }, [showInput2]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  const handleKeyDown1 = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit1(event);
    }
  };

  const handleKeyDown2 = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit2(event);
    }
  };

  return (
    <>
      <div className="frame1 animated-frame">Please Enter Your Name:
        {showInput && (
          <div className="message">
            <input
              type="text"
              className="input-text"
              placeholder="Enter your name"
              onKeyDown={handleKeyDown}
              value={name}
              onChange={handleChange}
              ref={nameRef}
            />
            <button className="submit-button" onClick={handleSubmit}></button>
          </div>
        )}
      </div>

      {showFrame && (
        <>
          <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            You {time?.toLocaleTimeString()}
          </div>
          <div className="you-message">
            <div className="frame2 animated-frame"><b>{name}</b></div>
          </div>

          <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
          </div>

          <div className="frame1 animated-frame"><b>Akaay Dairy: </b>Please Enter Your Mobile Number:
            {showInput1 && (
              <div className="message">
                <input
                  type="text"
                  className="input-text"
                  placeholder="Enter Your Mobile Number"
                  value={mobile}
                  onKeyDown={handleKeyDown1}
                  onChange={handleChange1}
                  ref={mobileRef}
                />
                <button className="submit-button" onClick={handleSubmit1}></button>
              </div>
            )}
          </div>
        </>
      )}

      {showFrame1 && (
        <>
          <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className="you-message">
            <div className="frame2 animated-frame"><b>{mobile}</b></div>
          </div>

          <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time1.toLocaleTimeString()}</div>
          </div>

          <div className="frame1 animated-frame"><b>Akaay Dairy: </b>Please Enter Your Email:
            {showInput2 && (
              <div className="message">
                <input
                  type="email"
                  className="input-text"
                  placeholder="Enter Your Email"
                  value={email}
                  onKeyDown={handleKeyDown2}
                  onChange={handleChange2}
                  ref={emailRef}
                />
                <button className="submit-button" onClick={handleSubmit2}></button>
              </div>
            )}
          </div>
        </>
      )}

      {showFrame2 && (
        <>
          <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            You {time2?.toLocaleTimeString()}
          </div>
          <div className="you-message">
            <div className="frame2"><b>{email}</b></div>
          </div>

          {loading ? <div className="frame1 animated-frame"><LoadingDots /></div> : <Mainmenu />}
        </>
      )}
    </>
  );
};

export default Details;
